const routes = {
    home: "/",
    bicicletas: "/bicicletas",
    nosotros: "/nosotros",
    contacto: "/contacto",
    faq: "/faq",
    producto: "/producto",
    administracion: "/administracion",
    pedidos: "/pedidos",
    login: "/login",
    registro: "/registro",
    checkout: "/checkout",
    confirmation: "/confirmation",
    paySucess: "/paySuccess"
}

export  {routes}